import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M20 12H4v8h16zM4 10c-1.1046 0-2 .8954-2 2v8c0 1.1046.8954 2 2 2h16c1.1046 0 2-.8954 2-2v-8c0-1.1046-.8954-2-2-2z",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#fff",
        d: "M8 17c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h8c1.1046 0 2 .8954 2 2v11c0 1.1046-.8954 2-2 2z"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 4v11h8V4zM6 15c0 1.1046.8954 2 2 2h8c1.1046 0 2-.8954 2-2V4c0-1.1046-.8954-2-2-2H8c-1.1046 0-2 .8954-2 2z",
        clipRule: "evenodd"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M5 16c0-.5523.4477-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.5523 0-1-.4477-1-1",
        clipRule: "evenodd"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.0812 7.1863c.4494.321.5535.9456.2325 1.395l-2.5 3.5a1 1 0 0 1-1.4137.2188l-2-1.5c-.4418-.3314-.5314-.9582-.2-1.4.3314-.4419.9582-.5314 1.4-.2l1.1812.8859 1.9051-2.6672c.321-.4494.9455-.5535 1.3949-.2325",
        clipRule: "evenodd"
    }, "4")
], "CreativeGoTV", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
